<template>
    <!-- Icons Grid -->
    <section class="features-icons bg-light text-center">
        <div class="container">
        <div class="row">
            <div class="col-lg-4">
            <div class="features-icons-item mx-auto mb-5 mb-lg-0 mb-lg-3">
                <div class="features-icons-icon d-flex">
                <i class="fa fa-chart-line m-auto text-primary"></i>
                </div>
                <h3>Traffic Driving Strategies</h3>
                <p class="lead mb-0">This theme will look great on any device, no matter the size!</p>
            </div>
            </div>
            <div class="col-lg-4">
            <div class="features-icons-item mx-auto mb-5 mb-lg-0 mb-lg-3">
                <div class="features-icons-icon d-flex">
                <i class="fa fa-chart-pie m-auto text-primary"></i>
                </div>
                <h3>Monetizing Users</h3>
                <p class="lead mb-0">Featuring the latest build of the new Bootstrap 4 framework!</p>
            </div>
            </div>
            <div class="col-lg-4">
            <div class="features-icons-item mx-auto mb-0 mb-lg-3">
                <div class="features-icons-icon d-flex">
                <i class="fa fa-file-invoice-dollar m-auto text-primary"></i>
                </div>
                <h3>Finding Partners</h3>
                <p class="lead mb-0">Ready to use with your own content, or customize the source files!</p>
            </div>
            </div>
        </div>
        </div>
    </section>
</template>

<script>
export default {
    name: 'DetailA',
    data: function() {
        return {

        }
    }
}
</script>

<!-- Custom Styles -->
<style>

</style>
